import { QuantitySelector } from "//hydraid.com/cdn/shop/t/172/assets/theme.js?v=107536070886860317671763387022";
import {formatMoney} from "//hydraid.com/cdn/shop/t/172/assets/theme.js?v=107536070886860317671763387022";

class CustomQuantitySelector extends QuantitySelector {
  connectedCallback() {
    super.connectedCallback();
    this.inputElement = this.querySelector('.quantity-input');
    this.minusButton = this.querySelector('button:first-of-type');
    this.plusButton = this.querySelector('button:last-of-type');

    this.minusButton.addEventListener('click', () => this.changeQuantity());
    this.plusButton.addEventListener('click', () => this.changeQuantity());
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  changeQuantity(amount) {
    this.inputElement.dispatchEvent(new Event('change', { 'bubbles': true }));
  }
}

window.customElements.define('custom-quantity-selector', CustomQuantitySelector);



class MultiVariantPicker extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeElements();
    this.addEventListeners();
    this.checkInputValues();
  }

  initializeElements() {
    this.addButton = this.querySelector('.multi-variant-picker__add-button-wrapper button');
    this.quantityButtons = this.querySelectorAll('.quantity-selector__button');
    this.productForm = this.querySelector('product-form');
    this.addButton.disabled = true;
  }

  addEventListeners() {
    this.addButton.addEventListener('click', () => this.handleAddButtonClick());
    this.querySelectorAll('input').forEach(input => {
      input.addEventListener('input', () => this.checkInputValues());
    });
    this.quantityButtons.forEach(button => {
      button.addEventListener('click', () => this.checkInputValues());
    });
  }

  handleAddButtonClick() {
    this.addButton.setAttribute("disabled", "disabled");
    this.addButton.setAttribute("aria-busy", "true");
    this.addItemsToCart();
  }

  checkInputValues() {
    const formData = this.collectFormData();
    const filteredFormData = Object.fromEntries(
      Object.entries(formData).filter(([key]) => !key.startsWith('price-'))
    );
    const totalQuantity = Object.values(filteredFormData).reduce((sum, value) => sum + parseInt(value, 10), 0);
    this.addButton.disabled = totalQuantity <= 0;
    this.updatePricing();
  }

  addItemsToCart() {
    const formData = this.collectFormData();
    const itemsArray = this.prepareItemsArray(formData);
    if (itemsArray.length > 0) {
      this.addToCart(itemsArray);
    }
  }

  collectFormData() {
    const formData = new FormData();
    const inputs = this.querySelectorAll('input');
    inputs.forEach(input => formData.append(input.name, input.value));
    return Object.fromEntries(formData.entries());
  }

  prepareItemsArray(formData) {
    let itemsArray = [];
    for (let variantId in formData) {
      if (!variantId.includes('price')){
        let quantity = parseInt(formData[variantId], 10);
        if (quantity > 0) {
          itemsArray.push({
            'id': parseInt(variantId, 10),
            'quantity': quantity
          });
        }
      }
    }
    return itemsArray;
  }

  async addToCart(itemsArray) {
    try {
      let sectionsToBundle = ["variant-added"];
      document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));
      const sectionToRerender = sectionsToBundle.join(",");
      this.addButton.setAttribute("disabled", "disabled");
      this.addButton.setAttribute("aria-busy", "true");
      let errorText = this.querySelector('.multi-variant-picker__errors');

      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest' 
        },
        body: JSON.stringify({ sections: sectionToRerender, items: itemsArray })
      });

      const responseJson = await response.json();

      this.addButton.removeAttribute("disabled");
      this.addButton.removeAttribute("aria-busy");

      if (response.ok) {
        if (window.themeVariables.settings.cartType === "page" || window.themeVariables.settings.pageType === "cart") {
          return window.location.href = `${Shopify.routes.root}cart`;
        }
        const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
        cartContent["sections"] = responseJson["sections"];

        document.documentElement.dispatchEvent(new CustomEvent("variant:add", {
          bubbles: true,
          detail: {
            items: responseJson.hasOwnProperty("items") ? responseJson["items"] : [responseJson],
            cart: cartContent
          }
        }));

        document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
          bubbles: true,
          detail: {
            baseEvent: "variant:add",
            cart: cartContent
          }
        }));
      } else {
        this.dispatchEvent(new CustomEvent("cart:error", {
          bubbles: true,
          detail: {
            error: responseJson["description"]
          }
        }));
      }

      if (responseJson.status == 422){
        errorText.innerHTML = responseJson.description;
      } else{
        errorText.innerHTML = '';
      }

      console.log('Items added to cart:', responseJson);
    } catch (error) {
      console.error('Error:', error);
    }
  }

  updatePricing() {
    const formData = this.collectFormData();
    const itemsArray = this.prepareItemsArray(formData);
    const { totalPrice, comparePrice, totalQuantity, discountPercent } = this.calculatePricing(itemsArray);
    this.updatePriceUI(totalPrice, comparePrice, totalQuantity, discountPercent);
  }
  
  calculatePricing(itemsArray) {
    let totalPrice = 0, comparePrice = 0, totalQuantity = 0;
    let discountPercent = parseFloat(this.dataset.discount || "0");
    let discountCount = parseFloat(this.dataset.discountCount || "0");

    const firstItem = itemsArray[0];

    if (firstItem && firstItem.id) {
        const price = parseFloat(this.querySelector(`input[name="price-${firstItem.id}"]`).value);
        
        itemsArray.forEach(item => {
            totalQuantity += item.quantity;
        });

        comparePrice = price;

        if (discountPercent > 0 && totalQuantity >= discountCount) {
            totalPrice = price - (price * discountPercent / 100); 
        } else {
            totalPrice = price;  
        }
    }

    return { totalPrice, comparePrice, totalQuantity, discountPercent };
  } 

  
  updatePriceUI(totalPrice, comparePrice, totalQuantity, discountPercent) {
    let currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
    let priceContainer = document.querySelector('.product-info__price sale-price');
    let priceCompareContainer = document.querySelector('.product-info__price compare-at-price');
    let savingsBadge = document.querySelector('on-sale-badge[discount-mode="saving"]');
    this.translationSave = this.dataset.translationSave;

    priceContainer.innerHTML = formatMoney(totalPrice, currencyFormat);

    if (totalQuantity >= parseFloat(this.dataset.discountCount || "0") && discountPercent) {
        priceCompareContainer.innerHTML = formatMoney(comparePrice, currencyFormat);
        priceCompareContainer.removeAttribute('hidden');
        priceContainer.classList.add('text-on-sale');

        savingsBadge.innerHTML = `${this.translationSave} ${Math.round(discountPercent)}%`;
        savingsBadge.removeAttribute('hidden');  
    } else {
        priceCompareContainer.setAttribute('hidden', 'true');
        priceContainer.classList.remove('text-on-sale');
        savingsBadge.setAttribute('hidden', 'true'); 
    }
  }
}

window.customElements.define('multi-variant-picker', MultiVariantPicker);


class IncentiveBar extends HTMLElement {
  constructor() {
    super();
    this.currencyFormat = window.themeVariables.settings.currencyCodeEnabled
      ? window.themeVariables.settings.moneyWithCurrencyFormat
      : window.themeVariables.settings.moneyFormat;
    this.onCartChanged = this.onCartChanged.bind(this);
  }

  connectedCallback() {
    document.addEventListener('cart:change', this.onCartChanged);
    this.updateBar();
  }

  disconnectedCallback() {
    document.removeEventListener('cart:change', this.onCartChanged);
  }

  addLevelUpAnimation(progressBar) {
    progressBar.classList.add('level-up');
    progressBar.addEventListener('animationend', () => progressBar.classList.remove('level-up'));
  }

  updateBar() {
    let totalPrice = parseFloat(this.getAttribute('total-price')) || 0;
    
    totalPrice = totalPrice / 100; // Convert to the base currency unit (e.g., from cents to dollars)
    const progressBar = this.querySelector('.incentive-bar__progress');
    const barRange = parseFloat(this.getAttribute('bar-range')) || 0;
    const maxProgressWidth = 90; // Use 90% of the bar to represent the max cart value

    // Calculate width relative to bar range, capped at 90%
    let progressWidth = (totalPrice / barRange) * maxProgressWidth;
    if (progressWidth > 90) {
        progressWidth = 100;
    }
    progressBar.style.width = `${progressWidth}%`; // Set the width of the progress bar.

    // Update milestones to fit within the 90% filled bar.
    const milestones = this.querySelectorAll('.incentive-bar__milestone');
    const highestMilestoneValue = Math.max(...Array.from(milestones).map(milestone => parseFloat(milestone.dataset.milestoneThreshold)));
    milestones.forEach(milestone => {
      const milestoneValue = parseFloat(milestone.dataset.milestoneThreshold);
      const milestonePosition = (milestoneValue / highestMilestoneValue) * maxProgressWidth;
      milestone.style.left = `${milestonePosition}%`;

      // Update milestone unlocked status and add animation if necessary
      milestone.classList.toggle('unlocked', totalPrice >= milestoneValue);

      // New code to display the horizontal product
      const milestoneIndex = milestone.dataset.milestoneKey;
      const productElement = document.querySelector(`.cart__gift[data-milestone-product-key="${milestoneIndex}"]`);
      if (productElement) {
        if (totalPrice >= milestoneValue) {
          productElement.classList.remove('hidden');
          document.body.classList.add('cart-quick-add-gift');
        } else {
            productElement.classList.add('hidden');
          document.body.classList.remove('cart-quick-add-gift');
        }
      }

      // Level up animation only if new milestone
      if (totalPrice >= milestoneValue && this.lastTotalPrice < milestoneValue) {
        this.addLevelUpAnimation(progressBar);
      }
    });

    // Update the description text to show the amount needed to reach the next milestone or success message if highest milestone is reached.
    const descriptionData = this.querySelector('.incentive-bar__description-text');
    const milestonesArray = Array.from(milestones);
    const nextMilestone = milestonesArray.find(milestone => totalPrice < parseFloat(milestone.dataset.milestoneThreshold));

    if (nextMilestone) {
      // There is a next milestone, so calculate the amount needed to reach it and update the description.
      const milestoneKey = nextMilestone.dataset.milestoneKey;
      const milestoneThreshold = parseFloat(nextMilestone.dataset.milestoneThreshold);
      const amountToNextMilestone = (milestoneThreshold - totalPrice) * 100;
      const descriptionTextTemplate = descriptionData.dataset[`text-${milestoneKey}`];
      const descriptionText = descriptionTextTemplate.replace('[PRICE]', formatMoney(amountToNextMilestone, this.currencyFormat));
      descriptionData.innerHTML = descriptionText;
    } else if (totalPrice >= barRange) {
      // The highest milestone is reached, show the success message.
      descriptionData.innerHTML = descriptionData.dataset.textSuccess;
    }
    // Remember the last total price to determine if a new milestone is reached on update.
    this.lastTotalPrice = totalPrice;
  }

  calculateProgress(value, min, max) {
    return ((value - min) / (max - min)) * 100;
  }

  onCartChanged({ detail }) {
    const totalPrice = detail.cart.items.reduce((sum, item) => sum + item.final_line_price, 0);
    this.setAttribute('total-price', totalPrice);
    this.updateBar();
  }
}

if (!customElements.get('incentive-bar')) {
  customElements.define('incentive-bar', IncentiveBar);
}



class CustomDropdown extends HTMLElement {
  connectedCallback() {
    this.querySelector('.selected-option').addEventListener('click', () => {
      this.querySelector('.options').classList.toggle('show');
    });

    this.querySelectorAll('.option').forEach(option => {
      option.addEventListener('click', () => {
        const value = option.getAttribute('data-value');
        const text = option.querySelector('.option-title').textContent;
        // this.querySelector('.selected-option .option-title div').textContent = text;
        // this.querySelector('.options').classList.remove('show');
        window.location.href = value;
      });
    });

    document.addEventListener('click', (event) => {
      if (!event.target.closest('custom-dropdown')) {
        this.querySelector('.options').classList.remove('show');
      }
    });
  }
}

window.customElements.define('custom-dropdown', CustomDropdown);

















document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.video-media-custom--play').forEach((videoMedia) => {
    const playButton = videoMedia.querySelector('.video-play-button');
    const pauseButton = videoMedia.querySelector('.video-pause-button');
    const videoDesktop = videoMedia.querySelector('.custom-video-element');
    const videoMobile = videoMedia.querySelector('.custom-video-element--mobile');
    const posterImage = videoMedia.querySelectorAll('img');
    const allowPause = videoMedia.dataset.pause === 'true';
    const shouldAutoplay = videoMedia.hasAttribute('autoplay');

    // Helper function to select the correct video element based on viewport size.
    const getVideoElement = () => {
      const isMobile = window.innerWidth < 768;
      return isMobile && videoMobile ? videoMobile : videoDesktop;
    };
    
    const videoEl = getVideoElement();
    const showControls = videoMedia.dataset.controls === 'true';

    if (videoEl) {
      // Prevent clicks on video element itself, but not on controls
      videoEl.addEventListener('click', (event) => {
        const isControlsClick = event.target.closest('[controls]');
        if (!isControlsClick) {
          event.preventDefault();
          event.stopPropagation();
        }
      });


      if (shouldAutoplay && !allowPause) {
        playButton.style.display = 'none';
      }

      
      if (shouldAutoplay && allowPause) {
        // Show pause button directly if autoplay and pause are allowed
        if (pauseButton) {
          pauseButton.style.display = 'block';
          playButton.style.display = 'none';
          pauseButton.addEventListener('click', (event) => {
            event.preventDefault();
            if (videoEl.paused) {
              videoEl.play();
              pauseButton.style.display = 'block';
              playButton.style.display = 'none';
            } else {
              videoEl.pause();
              pauseButton.style.display = 'none';
              playButton.style.display = 'block';
            }
          });
        } 
      } else {
        if (playButton) {
          playButton.addEventListener('click', (event) => {
            event.preventDefault();
            playButton.style.display = 'none';
            if (pauseButton && allowPause && !showControls) {
              pauseButton.style.display = 'block';
            }
            if (showControls) {
              videoEl.controls = true;
            }
            videoEl.play();
          });
        }

        if (pauseButton && allowPause && !showControls) {
          pauseButton.addEventListener('click', (event) => {
            event.preventDefault();
            pauseButton.style.display = 'none';
            playButton.style.display = 'block';
            videoEl.pause();
          });
        }
      }
    } else {
      console.log('Video element not found');
    }

    if (videoEl) {
      const mediaWrapper = videoEl.closest('.media-with-text__media, .multi-column__item, .images-scrolling-mobile__item');
      if (mediaWrapper && shouldAutoplay) {
        mediaWrapper.addEventListener('click', (event) => {
          if (shouldAutoplay) {
            pauseButton.click();
          } else {
            playButton.click();
          }
        });
      }
    }
  });
  

});


  // General click listener for the entire page
  document.addEventListener('click', (event) => {
    console.log('Clicked element:', event.target);
  });